"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRIVACY_POLICY = void 0;
const PRIVACY_POLICY = exports.PRIVACY_POLICY = 'privacy-policy';